module.exports = __webpack_public_path__ + "img/05.f7d264d6.png";